<template>
<!--  人像美颜-->
  <div class="fair-wrapper flex">
    <div class="fair-header">
<!--      <Slider :max="100" :step="20" />-->
      <vue-slider
        :max="100"
        :interval="20"
        tooltip="none"
        @change="handleChange"
        v-model="fairVal" />
    </div>
    <div class="fair-type-content flex">
      <div
        class="type-item flex"
        v-for="(item, index) in types"
        :key="`type_item_${item.value}`"
        :class="{active: item.value === activeType}"
        @click="activeType = item.value">
        <span class="iconfont" :class="item.icon" />
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import active from "@/views/questionnaire/active.vue";

export default {
  props: {
    nowFair: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      fairVal: 0,
      types: [
        { label: '磨皮', value: 'skinsoft', icon: 'iconmopi' },
        { label: '嘴巴', value: 'mouthlarge', icon: 'iconzuiba' },
        { label: '美白', value: 'skinwhite', icon: 'iconmeibai' },
        { label: '瘦脸', value: 'facelift', icon: 'iconshoulian' },
        { label: '左眼', value: 'leyelarge', icon: 'iconyanjingfangda' },
        { label: '右眼', value: 'reyelarge', icon: 'iconyanjingfangda' },
        { label: '亮眼', value: 'coseye', icon: 'iconliangyan' }
      ],
      activeType: 'skinsoft'
    }
  },
  watch: {
    nowFair: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        this.fairVal = val[this.activeType]
      }
    },
    activeType: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        this.fairVal = this.nowFair[val]
      }
    }
  },
  methods: {
    handleChange(value) {
      console.log(value, this.activeType)
      this.$emit('fairChange', { type: this.activeType, data: value })
    }
  }
}
</script>
<style lang="scss" scoped>
.fair-wrapper {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 40px 0;
  flex-direction: column;
  justify-content: space-between;
  .fair-header {
    padding: 0 20px;
  }
  .fair-type-content {
    align-items: center;
    justify-content: center;
    gap: 22px;
    .type-item {
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 4px;
      font-size: 12px;
      color: #606060;
      .iconfont {
        font-size: 20px;
        color: #404040;
      }
      &.active {
        color: #679CFF;
        .iconfont {
          color: #679CFF;
        }
      }
    }
  }
}
</style>
